export const isColdTub = (() => {
    const brand = localStorage.getItem('data-brand');
    if (brand) return brand === 'coldtub';
    return window.location.hostname.includes('mycoldtub');
})();

export const palName = isColdTub ? 'COLDTUB™ Pal' : 'Spa Boy';

export const shortPalName = isColdTub ? 'CT™ Pal' : 'Spa Boy';

export const localizePal = (text: string): string => {
    if (!text) return text;
    if (isColdTub) {
        return text.replace(/SPA ?BOY/gi, 'COLDTUB™ Pal');
    }
    return text.replace(/SpaBoy/g, 'Spa Boy').replace(/SPABOY/g, 'SPA BOY');
};

export const localizeSpa = (text: string): string => {
    if (!text || !isColdTub) return text;
    return text.replace(/Spas/g, 'COLDTUBS™').replace(/Spa/g, 'COLDTUB™');
};
